module.exports = __webpack_public_path__ + "img/logo-viettel.cde3bed7.png";